import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePartnerClients = Loadable({
  loader: function loader() {
    return import('../Partners/PartnerClients.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePartnerClients;